import { render, staticRenderFns } from "./PartnerSlide.vue?vue&type=template&id=4db574b4&scoped=true&"
import script from "./PartnerSlide.vue?vue&type=script&lang=js&"
export * from "./PartnerSlide.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSlide.vue?vue&type=style&index=0&id=4db574b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db574b4",
  null
  
)

export default component.exports